module.exports = __webpack_public_path__ + "img/wave-down.a3fb91d9.svg";